import GLightbox from 'glightbox';

export default {
  init() {
  },
  finalize() {

    const lightbox = GLightbox();

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/post-type-archive-creative.js